// List of images for the card carousel
export const cardImages = [
  require('../../img/page-1.png'),
  require('../../img/page-2.png'),
  require('../../img/page-3.png'),
  require('../../img/page-4.png'),
  require('../../img/page-5.png'),
  require('../../img/page-6.png'),
  require('../../img/page-7.png'),
  require('../../img/page-8.png'),
  require('../../img/page-9.png'),
    require('../../img/page-10.png'),
];
